const symbolSearchColumns = {
  groupingId: {
    key: 'groupingId',
    label: 'grouping',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  labSampleCode: {
    key: 'labSampleCode',
    label: 'labSampleId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  analysisCode: {
    key: 'analysisCode',
    label: 'analysisId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  analysisDescription: {
    key: 'analysisDescription',
    label: 'analysisDescriptionFull',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  sequence: {
    key: 'sequence',
    label: 'sequence',
    type: 'text',
    minWidth: 80,
    sortable: false,
  },
  operation: {
    key: 'operation',
    label: 'operation',
    type: 'text',
    minWidth: 90,
    sortable: false,
  },
  symbolType: {
    key: 'symbolType',
    label: 'symbolType',
    type: 'enum',
    enum: 'symbolTypes',
    minWidth: 80,
    sortable: false,
  },
  symbol: {
    key: 'symbol',
    label: 'symbol',
    type: 'text',
    minWidth: 70,
    sortable: false,
  },
  symbolLot: {
    key: 'symbolLot',
    label: 'lot',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
};

export default symbolSearchColumns;
